import Approvals from './customers'
export default Approvals
